import { render, staticRenderFns } from "./gelenEFaturaListesi.vue?vue&type=template&id=28ea5888&"
import script from "./gelenEFaturaListesi.vue?vue&type=script&lang=js&"
export * from "./gelenEFaturaListesi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports